module.exports = __webpack_public_path__ + "img/Villa_Borna_42.d3e38a49.jpg";